import { render, staticRenderFns } from "./tempPerubahanTPG.vue?vue&type=template&id=9d25a182&"
import script from "./tempPerubahanTPG.vue?vue&type=script&lang=js&"
export * from "./tempPerubahanTPG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports